export const NOTIFICATIONS_API_URL = {
  getHistory: (offset: number, limit: number, id: number) =>
    `/v2/events/${id}?offset=${offset}&limit=${limit}`,
};
